import type { TransformationsCssFeature } from './transformations.types'
import { transformationsVariants } from './transformationsVariantsCompNode'
import { transformations } from './transformationsCompNode'
import { transformationsDomApplier } from './transformationsDomApplier'

export const transformationsCssFeature: TransformationsCssFeature = {
	experimentName: 'specs.thunderbolt.catharsis_transformations_style',
	renderableNodes: { transformationsVariants, transformations },
	intermediateNodes: {},
	dataMaps: ['variants_data', 'transformations_data'],
	domApplier: transformationsDomApplier,
}
